import { NotificationSeverity } from '../../shared/feedback/notifications';

export type TranslationLanguage = 'sv' | 'en' | 'fi';

export const translationLanguages: TranslationLanguage[] = ['sv', 'en', 'fi'];

export type TranslationDto = {
    key: string;
    translations: Record<TranslationLanguage, string | null>;
    translationsVersion: number;
};

export type UpdateTranslationInput = {
    translations: Partial<Record<TranslationLanguage, string>>;
};

export type NotificationTranslation = {
    key: string;
    severity: NotificationSeverity;
    feature: string;
};

export type RouteNotifications = {
    path: string;
    exact: boolean;
    keys: string[];
};
